import { Users } from 'lucide-react';
import { Organization } from '../../types/index';

interface OrganizationSettingsProps {
  organization?: Organization;
}

export function OrganizationSettings({ organization }: OrganizationSettingsProps) {
  if (!organization) return null;

  // In the admin context, we don't need to check for permissions - admin can edit everything
  
  return (
    <div className="bg-white shadow-sm rounded-xl p-4 sm:p-6 border border-gray-100">
      <div className="flex items-center space-x-3 mb-6">
        <Users className="h-6 w-6 text-menioo-green" />
        <h2 className="text-xl font-display font-bold text-menioo-navy">
          Organization Settings
        </h2>
      </div>

      <form className="space-y-6">
        <div className="grid gap-6 sm:grid-cols-2">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-menioo-navy mb-1">
              Organization Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              defaultValue={organization.name}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-menioo-green focus:ring-menioo-green sm:text-sm"
            />
          </div>

          <div>
            <label htmlFor="numberOfPersons" className="block text-sm font-medium text-menioo-navy mb-1">
              Number of Persons
            </label>
            <input
              type="number"
              name="numberOfPersons"
              id="numberOfPersons"
              min="1"
              max="20"
              defaultValue={organization.numberOfPersons || 1}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-menioo-green focus:ring-menioo-green sm:text-sm"
            />
            <p className="mt-1 text-xs sm:text-sm text-gray-500">
              This number will be used to adjust recipe portions
            </p>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="w-full sm:w-auto bg-menioo-green text-white px-4 py-2 rounded-md hover:bg-menioo-green-dark transition-colors focus:outline-none focus:ring-2 focus:ring-menioo-green focus:ring-offset-2"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  );
}